export class UserNotification {
  public message: string;
  public notificationCategory: NotificationCategory;
}

export enum NotificationCategory {
  Success = 'Success',
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error'
}
